import Navbar from "./LandingNavBar";
import FloatingButtons from "./FloatingButtons";
import Hero from "./Hero";
import About from "./About";
// import Features from "./Features";
import Contact from "./Contact";
// import Footer from "./Footer";
import Locations from "./Locations";

function HomePage(){

return(

<div>

<Navbar/>
<div>
    <Hero/>
     <About/>
    <Contact/>
    {/* <Features/> */}
     <Locations />
    <FloatingButtons />
</div>


</div>

)

}

export default HomePage;